import { useEffect, useState } from "react"
import cl from "./ValueText.module.css"
import gl from "../../../styles/Global.module.css";

import { useVariable } from "../../../hooks/useVariable"

const pow10 = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000];
const DEFAULT_DIGITS=1;

function roundValue(val, digits) {
    const num = Number(val);
    if (!Number.isFinite(num)) return '[*]';
    const mult = pow10[digits] || Math.pow(10, digits);
    return Math.round(num * mult) / mult;
}

const ValueText = ({props, className=""}) => {
      // const[value, setValue] = useState(NaN);
    let value = useVariable(props.varName);
    //const digits = props.digits ?? DEFAULT_DIGITS;
    //value = roundValue(value, digits);

    let sH, sL;
    const digits = props.digits ?? DEFAULT_DIGITS;
    let NUM = Number(value);
    if (!Number.isFinite(value)) {
      sH= '*';
      sL="";
    }
    else if (NUM == 0) {
      sL="";
      sH="0";
    }else{
    const mult = pow10[digits] || Math.pow(10, digits);
    let f = (Math.round(value * mult)+0.1) / mult;
    const s = f.toFixed(digits);
      sL = s.slice(-digits);
      sH = s.slice(0, -digits);
    }
  useEffect(()=>{
    
  }, [value])  
  return (
    <div className={[cl.wrapper, gl.noselect].join(" ")} ><span className={`${cl.value_text} ${className}`}>{props.name} {sH}</span><span className={cl.value_text_little}>{sL} </span><span className={cl.value_text}>{props.meas}</span></div>
  )
}

export default ValueText